/**
 * Toast alert component for quotation status update responses.
 * Toast Id is constructed using the status type, toast alert type
 * and quotation revision id.
 */
export const QUOTATION_UPDATE_ERROR_TOAST_ID = 'quotation-update-error-toast';
